<template>
    <div>
    <div class="head_top">
        <div class="head_content">
            <div class="logo">
                <div class="logo_img">
                </div>
                <div class="logo_title">
                    <div class="title_name">
                        江苏建通绿色工程有限公司
                    </div>
                    <div class="title-eng">
                        Jiang Su Jian Tong Lv Se Gong Cheng You Xian Gong Si
                    </div>
                </div>
            </div>
            <div class="search_area">
                <div class="search_ico">
                    <img src="./images/search.png">
                </div>
                <input type="text" width="260px" height="20px" v-model="searchValue" placeholder="输入关键字搜索" @change="searchClick()">
                <div
            class="search_button cursor"
            @click="searchClick"
          >站内搜索</div>
            </div>
        </div>
    </div>
    <div class="head_nav">
        <ul id="main " class="nav_content">
          <li> <router-link to="/Home"  ><i  class="el-input__icon el-icon-s-home"></i></router-link></li>
          <li> <router-link :to="{path:'/Column',query:{category:'worktrend'}}"  >走进建通 <i class="el-input__icon el-icon-caret-bottom"></i> </router-link>
            <ul class="drop">
              <div>
                <li> <router-link :to="{path:'/Column',query:{category:'worktrend'}}" >集团概况</router-link></li>
                
                <li> <router-link :to="{path:'/Column',query:{category:'analyse'}}" >公司概况</router-link></li>
                <li> <router-link :to="{path:'/Column',query:{category:'statisticaldata'}}" >公司荣誉</router-link
              ></li>
              </div>
            </ul>
          </li>
          <li> <router-link  :to="{path:'/Column',query:{category:'statisticalknowledge'}}" 
                >通知公告 <i  class="el-input__icon el-icon-caret-bottom"></i> </router-link
              >
            <ul class="drop">
              <div>  
                <li><router-link  :to="{path:'/Column',query:{category:'statisticalknowledge'}}"
                >通知</router-link
              ></li>
                <li><router-link   :to="{path:'/Column',query:{category:'gsgg'}}" 
                >公告公示</router-link></li>
              </div>
            </ul>
          </li>
          <li>  <router-link   :to="{path:'/Column',query:{category:'gsdt'}}" >新闻中心<i  class="el-input__icon el-icon-caret-bottom"></i> </router-link>
          <!-- <li> 新闻中心<i  class="el-input__icon el-icon-caret-bottom"></i>  -->
            <ul class="drop">
              <div>
                <li> <router-link   :to="{path:'/Column',query:{category:'jtdt'}}"  >信息资讯</router-link></li>
                <li> <router-link  :to="{path:'/Column',query:{category:'gsdt'}}"  >公司动态</router-link></li>
              </div>
            </ul>
          </li>
          <li>  <router-link  :to="{path:'/Column',query:{category:'statistics'}}"   >党建工作</router-link></li>
          <li> <router-link  :to="{path:'/Column',query:{category:'file'}}" >项目展示</router-link></li>
          <!-- <li> <router-link  :to="{path:'/Column',query:{category:'culture'}}"  >联系我们<i  class="el-input__icon el-icon-caret-bottom"></i> </router-link> -->
          <li> <router-link  :to="{path:'/Column',query:{category:'culture'}}"  >联系我们<i  class="el-input__icon el-icon-caret-bottom"></i> </router-link>
            <ul class="drop">
              <div>
                <li> <router-link  :to="{path:'/Column',query:{category:'people'}}" class="aaa">人才招募</router-link></li>
                <li><router-link   :to="{path:'/Column',query:{category:'culture'}}"  class="aaa">联系我们</router-link></li>
              </div>
            </ul>
          </li>
        </ul>
    </div>
</div>
</template>

<script >
export default{
  name:'pageHeader',
  data(){
    return{
      searchValue:''
    }
  },
  methods:{
    searchClick(){
      if(this.searchValue){
        console.log(this.searchValue,"searchValue123")
      this.$router.push({path:'searchColumn',query:{searchTxt:this.searchValue}})
      }else{
        this.$message.warning("请输入关键词进行检索")
      }
     
    }
  }
}
</script>

<style scoped lang="less">
 .search_button {
        width: 82px;
        height: 28px;
        background: #2C5CAC;
        border-radius: 4px;
        margin-right: 2px;
        color: #fff;
        text-align: center;
        line-height: 28px;
      }
.head_top {
    width: 100%;
    height: 160px;
    background: #29498C;

    .head_content {
        width: 1161px;
        margin: 0 auto;
        height: 160px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .logo {
            display: flex;
            flex-direction: row;

            .logo_img {
                width: 98px;
                height: 87px;
                background: url(./images/logo.png) no-repeat;
                background-size: 100% 100%;
            }

            .logo_title {
                display: flex;
                flex-direction: column;
                padding-left: 22px;

                .title_name {
                    font-size: 40px;
                    font-family: AlibabaPuHuiTiB;
                    color: #FFFFFF;
                    line-height: 55px;
                    letter-spacing: 1px;
                    text-shadow: 0px 0px 14px rgba(0, 0, 0, 0.05);
                }

                .title-eng {
                    padding-top: 1px;
                    font-size: 16px;
                    font-family: AlibabaPuHuiTiM;
                    color: #FFFFFF;
                    line-height: 22px;
                    letter-spacing: 1px;
                    text-shadow: 0px 0px 14px rgba(0, 0, 0, 0.05);
                }
            }

        }

        .search_area {
            width: 312px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 8px;
            border: 1px solid #244BA7;
            display: flex;
            flex-direction: row;
          align-items: center;
            .search_ico {
                padding: 10px;

                img {
                    width: 20px;
                    height: 20px;
                }

            }

            input {
                padding: 10px;
                font-size: 12px;
                color: #333;
                border: none;
                background: #fff;
                outline: none;
            }
        }
    }
}
ul,li{
    margin: 0; padding: 0;
}
.head_nav {
    width: 100%;
    height: 80px;
    background: #F2F4F7;
    border-bottom: 1px solid #D8D8D8;
}
// .nav_content{
//     width: 1160px; height: 80px; margin: 0 auto; 

// }

.nav_content{
  width: 1160px; height: 80px; 
//   background: url('../assets/nav-bg.png') no-repeat; 
  position: relative;
  background-size: 100% 100%;
  list-style: none;
  font-size: 18px;
font-family: AlibabaPuHuiTiR;
text-transform: uppercase;
margin: 0 auto;
// padding: 0 80px; 

}


.nav_content >li{
  
  display: inline-block;
  position: relative;
  padding: 0 43px; line-height: 80px;
  cursor: pointer;color: #41474B; 
  z-index: 5;
 text-align: center; 
border-right: 1px solid #D8D8D8;
}

.nav_content >li:hover{
    height: 80px; padding: 0 43px; 
background: #56A1F3;
color: #fff;
}
.nav_content >li:nth-child(1){
padding:0 13px;
}
.nav_content >li:nth-child(1) i{
    font-size: 25px;
}
li {
  margin: 0;
}
.nav_content >li:nth-child(1) a{
  display: inline-block;
  padding: 0 20px; 
}
.nav_content >li a{
display: block;
  color: #41474B; text-decoration: none;
} 
.nav_content >li>.drop{
  display: none;
}
.nav_content >li:hover>.drop{
  display: block;
}
.nav_content >li a:hover{
  display: block;
  color: #fff; text-decoration: none;
}
.drop {
  overflow: hidden;
  list-style: none;
  position: absolute;
  padding: 0;
  width: 100%;
  left: 0;
  top: 80px;

}
.drop div {
  -webkit-transform: translate(0, -100%);
  -moz-transform: translate(0, -100%);
  -ms-transform: translate(0, -100%);
  transform: translate(0, -100%);
  -webkit-transition: all 0.5s 0.1s;
  -moz-transition: all 0.5s 0.1s;
  -ms-transition: all 0.5s 0.1s;
  transition: all 0.5s 0.1s;
  position: relative;
  background: #FFFFFF;
box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.12);
border-radius: 4px;
border: 1px solid #D8D8D8;
}
.drop li {
  display: block; height: 40px; line-height: 40px;
  padding: 0;
  font-size: 14px;
  background: #fff !important;
   color: #41474B;
}
.drop li:hover {
  display: block;
  padding: 0;
 
  background: #F2F4F7 !important;color: #41474B;
}
.drop li > a:hover{
  color: #41474B;
}
.nav_content li:nth-child(1):hover ul div {
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.nav_content li:nth-child(1):hover ~ #marker {
  -webkit-transform: translate(0px, 0);
  -moz-transform: translate(0px, 0);
  -ms-transform: translate(0px, 0);
  transform: translate(0px, 0);
}

.nav_content li:nth-child(2):hover ul div {
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.nav_content li:nth-child(2):hover ~ #marker {
  -webkit-transform: translate(120px, 0);
  -moz-transform: translate(120px, 0);
  -ms-transform: translate(120px, 0);
  transform: translate(120px, 0);
}

.nav_content li:nth-child(3):hover ul div {
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.nav_content li:nth-child(3):hover ~ #marker {
  -webkit-transform: translate(240px, 0);
  -moz-transform: translate(240px, 0);
  -ms-transform: translate(240px, 0);
  transform: translate(240px, 0);
}

.nav_content li:nth-child(4):hover ul div {
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.nav_content li:nth-child(4):hover ~ #marker {
  -webkit-transform: translate(360px, 0);
  -moz-transform: translate(360px, 0);
  -ms-transform: translate(360px, 0);
  transform: translate(360px, 0);
}
.nav_content li:nth-child(4):hover ul div{
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.nav_content li:nth-child(5):hover ul div{
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.nav_content li:nth-child(5):hover ~ #marker {
  -webkit-transform: translate(480px, 0);
  -moz-transform: translate(480px, 0);
  -ms-transform: translate(480px, 0);
  transform: translate(480px, 0);
}
.nav_content li:nth-child(6):hover ul div {
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.nav_content li:nth-child(6):hover ~ #marker {
  -webkit-transform: translate(600px, 0);
  -moz-transform: translate(600px, 0);
  -ms-transform: translate(600px, 0);
  transform: translate(600px, 0);
}
.nav_content li:nth-child(7):hover ul div {
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.nav_content li:nth-child(7):hover ~ #marker {
  -webkit-transform: translate(600px, 0);
  -moz-transform: translate(600px, 0);
  -ms-transform: translate(600px, 0);
  transform: translate(600px, 0);
}
</style>
